interface MockBadgeProps {
  label?: string;
  title?: string;
}

const MockBadge = ({
  label = "MOCK DATA",
  title = "This UI element is not yet wired to a real backend. Visible only to admins.",
}: MockBadgeProps): JSX.Element => {
  return (
    <span
      title={title}
      style={{
        display: "inline-block",
        background: "rgba(255, 152, 0, 0.18)",
        color: "#cc7a00",
        padding: "2px 8px",
        borderRadius: 4,
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: 0.5,
        marginLeft: 8,
        verticalAlign: "middle",
        cursor: "help",
      }}
    >
      {label}
    </span>
  );
};

export default MockBadge;
